import { getDripFormTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const dripFormConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Drip Form Widget",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "title",
          label: "Title",
        },
        {
          type: "input",
          name: "subtitle",
          label: "Subtitle",
        },
        {
          type: "input",
          name: "btnText",
          label: "Button text",
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getDripFormTemplate({
        title: data.title,
        subtitle: data.subtitle,
        buttonText: data.btnText,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { dripFormConfig };
